<script setup lang="ts">
import { useRouter } from "vue-router";

const router = useRouter();

const props = defineProps<{
  name: string
  action?: (() => unknown)
  icon: any
  label: string
}>();
</script>

<template>
  <router-link v-if="!action" :to="{ name: name }" :class="{ 'is-active': router.currentRoute.value.name === name }">
    <div class="f-wrapper" :title="label">
      <component :is="icon" />
      <span>{{label}}</span>
    </div>
  </router-link>
  <button v-else @click="action()" class="reset-button" :title="label">
    <div class="f-wrapper">
      <component :is="icon" />
      <span>{{label}}</span>
    </div>
  </button>
</template>

<style scoped>
.reset-button,
a {
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  height: 100%;
  flex-grow: 1;
  flex-basis: 4rem;
  width: 4rem;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-color-layer-1);
  text-decoration: none;
  font-size: 0.75rem;

  &.is-active {
    color: var(--main-color);
  }

  &:hover .f-wrapper {
    background-color: var(--color-layer-2);
  }

  .f-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    span {
      display: inline-block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 0.25rem;
      padding-right: 0.25rem;
    }
  }

  &.is-active .f-wrapper {
    background-color: var(--color-layer-0);
  }
}
</style>
